<script>
import ModelCreateModal from './modal-create';
import FormsModel from "@/components/forms/bank_account";

export default {
  extends: ModelCreateModal,
  props: {
    modalTitle: {default() { return this.lodash.startCase(this.$t('bank_accounts.singular')) }},
    resourceRoute: {default: 'bank_accounts'},
    modelVariable: {default: 'bank_account'},
    form: {default() { return FormsModel; }}
  },
  methods: {
    store(value) {
      return this.$axios.post('/bank_accounts', value);
    }
  },
}
</script>
